import { URL_GET_SESSION_EXCLUDE_INCLUDE } from 'services/urls.js';
import API from 'services/api.js';
import { useAppSelector, useAppDispatch } from 'hooks';
import { useMutation } from 'react-query';

import { actionResetMessages } from 'components/messages/actions.js';
import {
	actionResetSessionIds,
	actionFetchSessionIds,
} from 'components/clientSessionSelect/sessionSelect/redux';

export type SessionExcludeModel = {
	isLoading: boolean;
	sessions: {
		SessionID: number;
		SessionName: string;
		isExcluded: boolean;
	}[];
	onAcceptClicked: () => void;
	onCancelClicked: () => void;
};

export const useSessionExcludeModel = (
	sessions: {
		SessionID: number;
		SessionName: string;
		isExcluded: boolean;
	}[],
	onFinished: () => void
): SessionExcludeModel => {
	const dispatch = useAppDispatch();
	const clientId = useAppSelector((state) => state.clientId);

	const post = useMutation({
		mutationFn: async () => {
			dispatch(actionResetMessages());
			for (const session of sessions) {
				await actionExcludeSession(session.SessionID, !session.isExcluded);
			}
		},
		onSuccess: () => {
			dispatch(actionResetSessionIds());
			if (clientId) dispatch(actionFetchSessionIds(clientId, true));
			onFinished();
		},
	});

	return {
		isLoading: post.isLoading,
		sessions,
		onAcceptClicked: post.mutate,
		onCancelClicked: onFinished,
	};
};

const actionExcludeSession = async (sessionId: number, exclude: boolean) => {
	const params = {
		sessionId: sessionId,
	};

	const body = {
		exclude: exclude ? '1' : '0',
	};

	const response = await API.post(URL_GET_SESSION_EXCLUDE_INCLUDE, body, {
		params,
	});
	const result = response.data[0];
	if (result?.updatedRows === 0)
		throw new Error(
			`Failed to update session ${sessionId}: ${result.message ?? 'No rows updated'}`
		);
};
